import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Divider } from '../../../../../components/mui/Core/index'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'

const EVENT_ICON = {
  HOLD_APPLIED: { Icon: ErrorIcon, color: '#cc3f0c' },
  HOLD_RELEASED: { Icon: CheckCircleIcon, color: '#2a7b5a' },
  ALLOCATION_SUBMITTED: { Icon: CheckCircleIcon, color: '#2db47d' },
  ALLOCATION_DEFERRED: { Icon: WarningIcon, color: '#e65100' },
  ORDER_UPDATED: { Icon: InfoIcon, color: '#5488db' },
  DEFAULT: { Icon: InfoIcon, color: '#b7b7b7' },
}

function AuditTimeline({ events }) {
  if (!events || events.length === 0) {
    return (
      <Box sx={{ py: 2, textAlign: 'center' }}>
        <Typography sx={{ fontFamily: 'AtlasGroteskRegular', fontSize: '0.85rem', color: '#b7b7b7' }}>
          No audit events yet.
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ position: 'relative', pl: 3 }}>
      {/* Vertical line */}
      <Box
        sx={{
          position: 'absolute',
          left: 10,
          top: 0,
          bottom: 0,
          width: 2,
          backgroundColor: '#e7e7e7',
          borderRadius: 1,
        }}
      />
      {events.map((event, idx) => {
        const { Icon, color } = EVENT_ICON[event.eventType] || EVENT_ICON.DEFAULT
        return (
          <Box key={event.eventId} sx={{ display: 'flex', mb: idx < events.length - 1 ? 2.5 : 0, position: 'relative' }}>
            {/* Dot */}
            <Box
              sx={{
                position: 'absolute',
                left: -22,
                top: 2,
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: '#ffffff',
                border: `2px solid ${color}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1,
              }}
            >
              <Icon sx={{ fontSize: 12, color }} />
            </Box>
            {/* Content */}
            <Box sx={{ ml: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <Typography sx={{ fontFamily: 'AtlasGroteskRegular', fontSize: '0.82rem', fontWeight: 600, color: '#262626' }}>
                  {event.eventType.replace(/_/g, ' ')}
                </Typography>
                {event.holdCode && (
                  <Box sx={{ backgroundColor: '#fdecea', color: '#cc3f0c', borderRadius: 1, px: 0.75, fontSize: '0.7rem', fontFamily: 'AtlasGroteskRegular', border: '1px solid #f5c0b0' }}>
                    {event.holdCode}
                  </Box>
                )}
                <Typography sx={{ fontFamily: 'AtlasGroteskRegular', fontSize: '0.75rem', color: '#b7b7b7', ml: 'auto' }}>
                  {event.eventAt ? new Date(event.eventAt).toLocaleString('en-US') : ''}
                </Typography>
              </Box>
              <Typography sx={{ fontFamily: 'AtlasGroteskRegular', fontSize: '0.8rem', color: '#606060', mt: 0.25 }}>
                {event.note}
                {event.actor && <Box component='span' sx={{ ml: 0.75, color: '#b7b7b7' }}>— {event.actor}</Box>}
              </Typography>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

AuditTimeline.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default AuditTimeline
